import { render, staticRenderFns } from "./AppMenuSection.vue?vue&type=template&id=4b72e6d5&scoped=true"
import script from "./AppMenuSection.vue?vue&type=script&lang=ts"
export * from "./AppMenuSection.vue?vue&type=script&lang=ts"
import style0 from "./AppMenuSection.vue?vue&type=style&index=0&id=4b72e6d5&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b72e6d5",
  null
  
)

export default component.exports